import {
  HOSTMAP_INFO_LIST_SET,
  HOSTMAP_INFO_LIST_REQ,
  HOSTMAP_INFO_LIST_SUCCESS,
  HOSTMAP_INFO_LIST_ERROR,
  HOSTMAP_INFO_UPDATE_LIST_REQ
} from './hostmap_info.type'
import Hostmap from '@/resources/collections/Hostmap'
import ApiRest from '@/api/api-rest'

const state = {
  hostmapInfoReqStatus: '',
  hostmapInfo: {}
}

const getters = {
  hostmapInfoReqStatus: state => state.hostmapInfoReqStatus,
  hostmapInfo: state => state.hostmapInfo
}

// Best Practice - updates state
const mutations = {
  [HOSTMAP_INFO_LIST_SET]: (state, data) => {
    state.hostmapInfo = data
  },
  [HOSTMAP_INFO_LIST_REQ]: state => {
    state.hostmapInfoReqStatus = 'loading'
  },
  [HOSTMAP_INFO_LIST_SUCCESS]: (state, data) => {
    state.hostmapInfoReqStatus = 'saved'
  },
  [HOSTMAP_INFO_LIST_ERROR]: (state, errMsg) => {
    state.hostmapInfoReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [HOSTMAP_INFO_LIST_REQ] (context, payload) {
    let range = ''
    if (!_.isEmpty(payload)) {
      range = `?starttime=${payload.starttime}&endtime=${payload.endtime}`
    }
    return new Promise((resolve, reject) => {
      context.commit(HOSTMAP_INFO_LIST_REQ)
      ApiRest()
        .get(`/hostmapinfo${range}`)
        // .get('static/json/hostmap.json')
        .then(({ data }) => {
          let agents = []
          if (!_.isUndefined(context.rootState.agents.agentList.models)) {
            agents = context.rootState.agents.agentList.models
          }
          let topology = new Hostmap()
          topology.setAgentModels(agents)
          topology.setAgentNodes(
            _.map(data, 'sourceAgent'),
            _.map(data, 'targetAgent')
          )
          topology.setLinks(data)
          context.commit(HOSTMAP_INFO_LIST_SET, topology)
          resolve(topology)
        })
        .catch(errMsg => {
          context.commit(HOSTMAP_INFO_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [HOSTMAP_INFO_LIST_SUCCESS] (context) {
    context.commit(HOSTMAP_INFO_LIST_SUCCESS)
  },
  [HOSTMAP_INFO_UPDATE_LIST_REQ] (context, payload) {
    let range = ''
    if (!_.isEmpty(payload)) {
      range = `?starttime=${payload.starttime}&endtime=${payload.endtime}`
    }
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/hostmapinfo${range}`)
        // .get('static/json/hostmap.json')
        .then(({ data }) => {
          let topology = context.state.hostmapInfo
          topology.updateAgentNodes(
            _.map(data, 'sourceAgent'),
            _.map(data, 'targetAgent')
          )
          topology.updateLinks(data)
          resolve(topology)
        })
        .catch(errMsg => {
          context.commit(HOSTMAP_INFO_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/hostmap_info/hostmap_info.module.js